import { APP_CONFIG } from '@/lib/app/config';
import { useQuery } from '@tanstack/react-query';
import { Platform } from 'react-native';

export type PublicStatusState = 'ok' | 'degraded' | 'down' | 'maintenance';

export type PublicStatusNotice = {
  id: string;
  type: 'incident' | 'maintenance' | 'status';
  severity: PublicStatusState | 'notice' | 'outage';
  title: string;
  message: string;
  affected_components: string[];
  starts_at?: string;
  ends_at?: string;
  upcoming?: boolean;
};

export type PublicStatusSnapshot = {
  status: PublicStatusState;
  checked_at: string;
  public_notice: PublicStatusNotice | null;
};

export const publicStatusQueryKey = ['public-status', APP_CONFIG.statusURL] as const;

export function usePublicStatus(enabled = true) {
  return useQuery({
    queryKey: publicStatusQueryKey,
    enabled: Platform.OS === 'web' && enabled,
    staleTime: 60_000,
    refetchInterval: 120_000,
    queryFn: async (): Promise<PublicStatusSnapshot> => {
      const response = await fetch(APP_CONFIG.statusURL, {
        headers: { accept: 'application/json' },
      });
      if (!response.ok) {
        throw new Error('status unavailable');
      }
      return response.json();
    },
  });
}
